<div id="qr-code" class="bg-primary">
    <div class="container">
        <div class="row" style="padding-top: 30%">
        <div class="text-center col-12">
            <div class="spinner-border color-accent" role="status">
            <span class="sr-only">Loading...</span>
            </div>
        </div>
        </div>

    </div>
    <div class="ups-spacer"></div>
</div>
  
